import { render, staticRenderFns } from "./WpHistoryExternalCommentBlock.vue?vue&type=template&id=5ab8ff1b&"
import script from "./WpHistoryExternalCommentBlock.vue?vue&type=script&lang=js&"
export * from "./WpHistoryExternalCommentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab8ff1b')) {
      api.createRecord('5ab8ff1b', component.options)
    } else {
      api.reload('5ab8ff1b', component.options)
    }
    module.hot.accept("./WpHistoryExternalCommentBlock.vue?vue&type=template&id=5ab8ff1b&", function () {
      api.rerender('5ab8ff1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/WpHistoryExternalCommentBlock.vue"
export default component.exports